import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Header,
  HeaderContainer,
  HeaderName,
  HeaderNavigation,
  HeaderMenuButton,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  Search,
  SkipToContent,
  SideNav,
  SideNavItems,
  HeaderSideNavItems,
} from "@carbon/react";

import { mainNavLinks } from "../../routes";
import { HoverDropDown } from "../HoverDropDown";

import house from '../../assets/icons/house2.svg'

const recent = 'Recent';
const Allinks = 'All Links'


export const View = () => {
  const hiddenTabNavLinks = mainNavLinks.filter((link) => link.isShowMore);
  return (
    <HeaderContainer
      render={({ isSideNavExpanded, onClickSideNavExpand }) => (
        <Header
          className="header-transparency-cover"
          aria-label="switchapp header wrapper"
        >
          <Header aria-label="switchapp header">
            <SkipToContent />
            <HeaderMenuButton
              aria-label="Open menu"
              onClick={onClickSideNavExpand}
              isActive={isSideNavExpanded}
            />
            <HeaderName prefix="" element={Link} to="/">
              <img
                src={`${process.env.PUBLIC_URL}/switchapp-logo.png`}
                alt="switchapp logo"
                className="app-logo"
              />
              <strong>
                <h6 className="header-name">SwitchApp</h6>
              </strong>
            </HeaderName>

            <HeaderNavigation aria-label="Account Switching">

              <HeaderMenuItem
                element={Link}
                to={"/"}
                className="more-content--link"
              >
                
                <HoverDropDown
                  text="Accounts"
                  className="main-tab--link"
                  contentClassName="more-content"
                >
                  <div className="user-accounts--container button--link">
                    
                   <img src={house} alt="house" /> 
                      New Business
                   
                  <br />
                  <br />
                  <img src={house} alt="house" /> 
                     New Account
                  </div>
                </HoverDropDown>
              </HeaderMenuItem>

              <HeaderMenuItem>
                <Search
                  size="sm"
                  placeholder="Search"
                  labelText="Search"
                  closeButtonLabelText="Clear search input"
                  id="app-search"
                  onChange={() => {}}
                  onKeyDown={() => {}}
                />
              </HeaderMenuItem>
              <HeaderMenuItem
                element={Link}
                to={"/"}
                className="more-content--link"
              >
                <HoverDropDown
              text="QuickLinks"
              className="main-tab--link"
              contentClassName="more-content"
            >
              {hiddenTabNavLinks.map((link) => (
                <NavLink
                  key={link.route}
                  to={link.route}
                  className="more-content--container"
                >
                  <div className="more-content--link">
                  <img
                          src={link.icon}
                          className="link-icon align-icon--center"
                          alt="link icon"
                        />
                       
                    <span className="link-name">{link.name}</span>
                  </div>
                </NavLink>
              ))}
            </HoverDropDown>
              </HeaderMenuItem>
            </HeaderNavigation>

            <SideNav
              className="side-nav--mobile-only"
              aria-label="Side navigation"
              expanded={isSideNavExpanded}
              isPersistent={false}
            >
              <SideNavItems>
                <HeaderSideNavItems>
                  {mainNavLinks.map((link) => (
                    <HeaderMenuItem
                      key={link.route}
                      element={NavLink}
                      to={link.route}
                    >
                      {link.name}
                    </HeaderMenuItem>
                  ))}

                  <hr />
                  <HeaderMenuItem element={Link} to={"/developers"}>
                    Developers
                  </HeaderMenuItem>

                  <HeaderMenuItem
                    element={Link}
                    to={"/settings"}
                    className="pad-bottom"
                  >
                    Settings
                  </HeaderMenuItem>
                </HeaderSideNavItems>
              </SideNavItems>
            </SideNav>

            <HeaderGlobalBar>
            <HeaderName prefix="" element={Link} to="/">
              <img
                src={`${process.env.PUBLIC_URL}/qmark.svg`}
                alt="switchapp logo"
                className="app-logo"
              />
              <strong>
                <p className="header-name-help">Help</p>
              </strong>
            </HeaderName>
              <HeaderGlobalAction
                tooltipAlignment="center"
              >
               <img
                src={`${process.env.PUBLIC_URL}/notification.png`}
                alt="notification logo"
                className="notification-logo"
              />
              </HeaderGlobalAction>
              <HeaderGlobalAction aria-label="Profile" tooltipAlignment="end">
              <img
                src={`${process.env.PUBLIC_URL}/User.svg`}
                alt="User logo"
                className="user-logo"
              />
              </HeaderGlobalAction>
            </HeaderGlobalBar>
          </Header>
        </Header>
      )}
    />
  );
};
